import React from 'react'
import styled from 'styled-components'
import { FilterItemType, FilterMap } from '@/modules/products/viewModels/ProductListViewModel'
import { SearchCheckboxModal } from '@/modules/products/components/SearchCheckboxModal'

export interface ProductFilterBoxProps {
	idx: number
	filterItems: FilterMap
	currentSelectedInBox: FilterItemType[]
	updateFilterItem: (filter: string, item: FilterItemType[]) => void
	deleteItem: any
}

const ProductFilterBoxWrapper = styled.div``

export const ProductFilterBox: React.FC<ProductFilterBoxProps> = ({
	idx,
	filterItems,
	currentSelectedInBox,
	updateFilterItem,
	deleteItem,
}) => {
	return (
		<ProductFilterBoxWrapper>
			<h1>단원/UNIT</h1>
			<SearchCheckboxModal
				idx={idx}
				checkboxList={currentSelectedInBox}
				filterItems={filterItems}
				updateFilterItem={updateFilterItem}
				deleteItem={deleteItem}
				// resetFilter={}
			/>
		</ProductFilterBoxWrapper>
	)
}
